import { ArrowRight, Globe } from "lucide-react";

const locations = ["United Kingdom", "United States", "Canada", "UAE", "Global Diaspora"];

export const DiasporaGuideSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="diaspora-guide-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      {/* Decorative corner accents */}
      <div className="absolute top-12 left-12 w-24 h-24 border-l border-t border-[#D4AF37]/15 hidden lg:block" />
      <div className="absolute bottom-12 right-12 w-24 h-24 border-r border-b border-[#D4AF37]/15 hidden lg:block" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            For Diaspora Investors
          </span>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white mt-4 md:mt-6 leading-tight">
            Buying Property in Nigeria Safely:
            <span className="block text-[#D4AF37] italic mt-2">A Guide for Diaspora Investors</span>
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8" />
        </div>

        {/* Content */}
        <div className="space-y-6 md:space-y-8 text-center max-w-3xl mx-auto">
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            Buying property in Nigeria from abroad can present excellent investment opportunities — but 
            it also carries significant legal risks when due diligence is not properly conducted.
          </p>
          
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            4 ACES Attorneys provides strategic legal guidance for diaspora investors seeking to acquire 
            property in Nigeria with confidence. Our firm conducts comprehensive property investigations, 
            verifies title authenticity, and ensures all legal documentation is properly structured before 
            any transaction is completed.
          </p>
          
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            We regularly assist clients based in the United Kingdom, the United States, Canada, the UAE, 
            and other parts of the global diaspora who wish to invest safely in Nigeria's property market.
          </p>
        </div>

        {/* Location badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-10 md:mt-12">
          {locations.map((location) => (
            <div 
              key={location}
              className="flex items-center gap-2 border border-[#D4AF37]/25 px-4 py-2 md:px-5 md:py-2.5 hover:border-[#D4AF37]/50 transition-colors"
            >
              <Globe className="w-3 h-3 md:w-4 md:h-4 text-[#D4AF37]" />
              <span className="text-white/60 text-xs md:text-sm">{location}</span>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-10 md:mt-14">
          <a
            href="#booking"
            className="inline-flex items-center gap-2 md:gap-3 bg-[#D4AF37] text-[#0A0A0B] px-8 md:px-10 py-4 md:py-5 font-semibold text-sm tracking-wide hover:bg-[#C5A028] transition-colors"
            data-testid="diaspora-guide-cta"
          >
            Book a Consultation
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
